import React, { memo } from 'react'
import { IVersion } from 'types/logs'
import { formatLogsTimestamp } from 'utils/formatDatetime'
import { logsColumnOrder, logsColumnOrderCondensed } from 'constants/logs'
import { ChangeEvents } from './ChangeEvents'
import { EventCell } from './EventCell'
import { UpdatedCell } from './UpdatedCell'

interface ILogsRowProps {
  version: IVersion
  /**
   * When true, Updated By and Time columns are combined into one Updated column
   * @optional
   * @default false
   */
  condensed?: boolean
}

export const LogsRow = memo<ILogsRowProps>(({ condensed = false, version }) => {
  const columnOrder = condensed ? logsColumnOrderCondensed : logsColumnOrder
  const data = {
    event: <EventCell version={version} condensed={condensed} />,
    time: formatLogsTimestamp(version.occurredAt),
    updated: <UpdatedCell version={version} condensed={condensed} />,
    change: <ChangeEvents version={version} condensed={condensed} />,
  } as { [key: string]: any }

  return (
    <tr>
      {columnOrder.map(({ key }) => (
        <td key={key}>{data[key]}</td>
      ))}
    </tr>
  )
})
